// DBK cookie law settings toggle
$('body').on('click', '#dbk-cookie-law .btn-show-cookie-setting', function() {
    let $toggle = $(this),
        $settings = $(this).closest('#dbk-cookie-law').find('.cookies-notification__bottom'),
        classToggled = 'btn-show-cookie-setting--toggled';

    if ($toggle.hasClass(classToggled)) {
        $toggle.removeClass(classToggled);
        $settings.stop().slideUp(150);
    } else {
        $toggle.addClass(classToggled);
        $settings.stop().slideDown(150);
    }
});